import script from "./AtomLegend.vue?vue&type=script&lang=ts&setup=true"
export * from "./AtomLegend.vue?vue&type=script&lang=ts&setup=true"

import "./AtomLegend.vue?vue&type=style&index=0&id=19b8d354&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19b8d354"]])

export default __exports__